import { render } from "./FormTagLogin.vue?vue&type=template&id=20e952fc"
import script from "./FormTagLogin.vue?vue&type=script&lang=js"
export * from "./FormTagLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__